import { render, staticRenderFns } from "./FinanceOld.vue?vue&type=template&id=e21e2ed8"
import script from "./FinanceOld.vue?vue&type=script&lang=js"
export * from "./FinanceOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports